import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useContext, useEffect, useState } from "react";
import { useAPIEditPengisianMinyak } from "../api/api-edit-pengisian-minyak";
import {
  genElDateObject,
  genElNumber,
  genElObject,
  genElTime,
  genElZirvuImage,
} from "../../../components/utils/EditorDialogElementGenerator";
import { ProgressSpinner } from "primereact/progressspinner";
import KendaraanSelectorDialog from "../../../dialogs/selectors/KendaraanSelectorDialog";
import JenisMinyakSelectorDialog from "../../../dialogs/selectors/JenisMinyakSelectorDialog";
import VerifAuthorizationDialog from "../../../dialogs/VerifAuthorizationDialog";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../store/ui-context";
import { useSelector } from "react-redux";

// const defaultVerifSettingPemakaian = {
//   jabatan_id: -1,
//   1: [],
//   2: [],
// };

// const defaultVerifSettingPengecekan = {
//   jabatan_id: -1,
//   admin: [],
// };

// const isSmallScreen = window.innerWidth < 640;

const PengisianMinyakEdit = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;

  const { requestPost } =
    useAPIRequest();
  const uiContext = useContext(UiContext);
  const employee = useSelector((state) => state.auth.employee);


  const [showKendaraanSelector, setShowKendaraanSelector] = useState(false);
  const [showJenisMinyakSelector, setShowJenisMinyakSelector] = useState(false);
  const [tempGambarFolderId, setTempGambarFolderId] = useState(null);

  const {
    loading,
    data,
    setData,
    fetchDataOrCreateNew,
    error,
    setError,
    handleOnConfirm,
  } = useAPIEditPengisianMinyak({ onConfirmed });

  // const fetchVerifSettingPengecekan = async () => {
  //   requestGet({
  //     fullUrl: "/api/user/verif",
  //     params: { filter: `label:contains:pengisian_minyak%` },
  //     onError: ({ message, data }) => {
  //       uiContext.showErrorMsg("Error", message);
  //     },
  //     onSuccess: ({ data, message }) => {
  //       if (data && data.length > 0) {
  //         const newVerifSetting = {
  //           ...defaultVerifSettingPengecekan,
  //           jabatan_id: employee.jabatan_id,
  //         };
  //         if (data) {
  //           for (const verifData of data) {
  //             const { id, label, jabatan_id } = verifData;
  //             const newVerifLabel = label
  //               .replace(`pengisian_minyak:`, "")
  //               .trim();
  //             newVerifSetting[newVerifLabel].push(jabatan_id);
  //           }
  //         }
  //         setVerifSettingPengecekan(newVerifSetting);
  //       }
  //     },
  //   });
  // };

  // const [verifSettingPengecekan, setVerifSettingPengecekan] = useState({
  //   ...defaultVerifSettingPengecekan,
  // });

  // use effect section

  useEffect(() => {
    if (visible) {
      if (!editorData?.id || editorData.id <= 0) {
        setTempGambarFolderId(`new_${Date.now()}`);
      }
      fetchDataOrCreateNew({ id: editorData.id, extraData: editorData });
    }
  }, [visible]);

  useEffect(() => {
    const rules = [
      { key: "kendaraan_id", isValid: data.kendaraan_id > 0 },
      { key: "jenis_minyak_id", isValid: data.jenis_minyak_id > 0 },
      { key: "speedo_akhir", isValid: data.speedo_akhir > 0 },
      { key: "tanggal", isValid: data.tanggal instanceof Date },
      { key: "jam", isValid: data.jam instanceof Date },
      { key: "harga_per_liter", isValid: data.harga_per_liter > 0 },
      { key: "jumlah", isValid: data.jumlah > 0 },
      { key: "total_harga", isValid: data.total_harga > 0 },
    ];

    setError((prev) => {
      const updated = { ...prev };

      rules.forEach((r) => {
        if (r.isValid) {
          delete updated[r.key];
        }
      });

      return updated;
    });
  }, [data]);

  useEffect(() => {
    if (data?.data_jenis_minyak && typeof data.jumlah === "number") {
      const harga = data.harga_per_liter ?? 0;
      const jumlah = data.jumlah ?? 0;
      const total = harga * jumlah;

      setData((prevData) => ({
        ...prevData,
        total_harga: total,
      }));
    }
  }, [data.data_jenis_minyak, data.jumlah, data.harga_per_liter]);

  useEffect(() => {
    if (data?.data_jenis_minyak) {
      const harga = data.data_jenis_minyak.harga_per_liter ?? 0;
      const total = data.jumlah * harga;

      setData((prevData) => ({
        ...prevData,
        harga_per_liter: harga,
        total_harga: total,
      }));
    }
  }, [data.data_jenis_minyak?.id]);

  // handle ui event section

  const handleOnConfirmKendaraan = (event, datas) => {
    if (datas && datas.length > 0) {
      const kendaraan = datas[0];
      setData((prevData) => ({
        ...prevData,
        data_kendaraan: kendaraan,
        kendaraan_id: kendaraan.id,
      }));
      setShowKendaraanSelector(false);
    }
  };

  const handleOnConfirmJenisMinyak = (event, datas) => {
    if (datas && datas.length > 0) {
      const jenisMinyak = datas[0];
      setData((prevData) => ({
        ...prevData,
        data_jenis_minyak: jenisMinyak,
        jenis_minyak_id: jenisMinyak.id,
      }));
      setShowJenisMinyakSelector(false);
    }
  };

  const handleOnSignDicekAdminKembali = async (props) => {
    let username = undefined;
    let password = undefined;

    if (props && props.username) {
      username = props.username;
    }

    if (props && props.password) {
      password = props.password;
    }

    const verifyResponse = await verify({
      username,
      password,
      label: "admin",
      verifLabel: "pengisian_minyak:admin",
      id: data.id,
      result_object_id: "verif_admin_id",
      result_object_datetime: "verif_admin_datetime",
      result_object_data: "data_verif_admin",
      data: data,
      setData: setData,
    });

    return verifyResponse;
  };

  const verify = async ({
    username,
    password,
    verifLabel,
    id,
    result_object_id,
    result_object_datetime,
    result_object_data,
    data,
    setData,
  }) => {
    const body = { data_id: id, label: verifLabel };
    if (username) body["username"] = username;
    if (password) body["password"] = password;

    // console.log("VERIF", body);

    return await requestPost({
      fullUrl: `api/user/verif`,
      body: body,
      onSuccess: ({ message, data: responseData }) => {
        if (responseData) {
          const newData = { ...data };
          newData[result_object_id] = responseData[result_object_id];
          newData[result_object_datetime] =
            responseData[result_object_datetime];
          newData[result_object_data] = responseData[result_object_data];
          setData(newData);

          uiContext.showSuccessMsg("Success", "Verifikasi berhasil");
        }
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  // genereate editor element section

  const elTanggal = genElDateObject({
    field: "tanggal",
    name: "Tanggal",
    value: data.tanggal,
    data,
    setData,
    error,
  });

  const elJam = genElTime({
    field: "jam",
    name: "Jam",
    value: data.jam,
    data,
    setData,
    error,
  });

  const elNomorPolisi = genElObject({
    field: "kendaraan_id",
    name: "No Polisi",
    value: data.data_kendaraan ? data.data_kendaraan.nomor_polisi : "",
    error,
    onClick: () => {
      setShowKendaraanSelector(true);
    },
  });

  const elLastKM = genElNumber({
    field: "data_kendaraan.speedo_akhir",
    value: data.data_kendaraan ? data.data_kendaraan.speedo_akhir : 0,
    data,
    setData,
    showButtons: false,
    error,
    disabled: true,
  });

  const elSpeedometer = genElNumber({
    field: "speedo_akhir",
    name: "KM Terkini",
    value: data.speedo_akhir ?? 0,
    data,
    setData,
    error,
  });

  const elJumlah = genElNumber({
    field: "jumlah",
    name: "Jumlah (Liter)",
    value: data.jumlah ?? 0,
    data,
    setData,
    error,
  });

  const elHarga = genElNumber({
    field: "harga_per_liter",
    name: "Harga per liter",
    value: data.harga_per_liter ?? 0,
    data,
    setData,
    error,
  });

  const elTotalHarga = genElNumber({
    field: "total_harga",
    name: "Total Harga",
    value: data.total_harga ?? 0,
    data,
    setData,
    error,
  });

  const elJenis = genElObject({
    field: "jenis_minyak_id",
    name: "Jenis",
    value: data.data_jenis_minyak ? data.data_jenis_minyak.nama : "",
    error,
    onClick: () => {
      setShowJenisMinyakSelector(true);
    },
  });

  const gambarFolderId = data.id && data.id > 0 ? data.id : tempGambarFolderId;
  const gambarFolderName =
    "pengisian_minyak/" +
    new Date().getFullYear() +
    "/" +
    (new Date().getMonth() + 1) +
    "/" +
    gambarFolderId;

  const elGambarSpeedoMeter = genElZirvuImage({
    field: "gambar_speedo_meter",
    name: "Foto Speedometer",
    folderName: gambarFolderName,
    data,
    setData,
    error,
  });

  const elGambarBon = genElZirvuImage({
    field: "gambar_bon",
    name: "Foto Bon",
    folderName: gambarFolderName,
    data,
    setData,
    error,
  });


  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          handleOnConfirm();
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "24rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={
        data.id && data.id > 0
          ? "Edit Pengisian Minyak"
          : "Tambah Pengisian Minyak"
      }
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      <VerifAuthorizationDialog loading={loading} />

      <KendaraanSelectorDialog
        title={"Pilih Kendaraan"}
        visible={showKendaraanSelector}
        onHide={() => setShowKendaraanSelector(false)}
        onConfirm={handleOnConfirmKendaraan}
      />

      <JenisMinyakSelectorDialog
        title={"Pilih Jenis Minyak"}
        visible={showJenisMinyakSelector}
        onHide={() => setShowJenisMinyakSelector(false)}
        onConfirm={handleOnConfirmJenisMinyak}
      />

      <div className="col-start-center relative h-100 gap-3">
        {elNomorPolisi}
        <div className="row-start-end w-full gap-3">
          {elTanggal}
          <div className="row-start-end">{elJam}</div>
        </div>
        <div className="col-start-start w-100 gap-1">
          <label className="font-bold text-sm text-red-500">
            KM Sebelumnya
          </label>
          {elLastKM}
        </div>
        {elSpeedometer}
        {elJenis}
        {elHarga}
        <div className="row-start-end w-full gap-3">
          {elJumlah}{" "}
          <span className="pb-2 font-semibold text-slate-500">Liter</span>
        </div>
        {elTotalHarga}
        {elGambarSpeedoMeter}
        {elGambarBon}
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default PengisianMinyakEdit;
